<template>
	<v-dialog 
		v-model="dialog.display" 
		max-width="420" 
		:persistent=isPersistent
		ref="dialog"
		v-if="idDisplay"
	>
		<v-card class="dialog-schedule-info">
			<v-card-title class="headline">
				<div v-if="hasSeveralSchedule">
					<v-btn fab flat absolute s
						class="pa-0 ma-0 dialog-schedule-delete"
						v-on:click="onDelete">
						<v-icon>delete</v-icon>
					</v-btn>
				</div>
				<v-btn fab flat absolute class="pa-0 ma-0 dialog-close"
					v-on:click="onClose">
					<v-icon>close</v-icon>
				</v-btn>
			</v-card-title>
			<v-container grid-list-xs class="dialog-schedule-info-content pb-0 pl-0 pr-1 pt-4">
				<div v-if="dialog.target != null">
					<v-layout wrap>
						<template  v-if="!isProjectSchedule">
							<v-flex offset-xs1 xs2 class="multi-line-label">タスク</v-flex>
							<v-flex xs9 class="pl-3 multi-line-label">
								<template v-if="isDisplayTaskName">
								{{ taskName }}
								</template>
							</v-flex>
						</template>
						<template>
							<v-flex offset-xs1 xs2 class="multi-line-label">案件</v-flex>
							<v-flex xs9 class=" pl-3 multi-line-label">
								<template v-if="isDisplayProjectName">
									{{ projectName }}
								</template>
							</v-flex>
						</template>
						<template v-if="!isProjectSchedule">
							<v-flex offset-xs1 xs2 class="multi-line-label member-label">メンバー</v-flex>
							<v-flex xs9 class="pl-3  multi-line-label">
								<template v-if="isDisplayMemberName">
									{{ memberName }}
								</template>
							</v-flex>
						</template>
					</v-layout>
					<v-layout wrap mt-3>
						<v-flex offset-xs1 xs2 class="multi-line-label">開始</v-flex>
						<v-flex xs5 class="pl-3">
							<template v-if="isEditable">
								<v-menu
									ref="begin_calendar"
									v-model="begin_calendar"
									:close-on-content-click="false"
									:nudge-right="40"
									lazy
									transition="scale-transition"
									full-width
								>
									<template v-slot:activator="{ on }">
										<v-btn flat block blue--text class="blue--text subheading calendar-btn" v-on="on">{{scheduleFormatYearMonthDay(dialog.target.begin)}}</v-btn>
									</template>
									<v-date-picker
										v-model="scheduleBegin"
										no-title
										@input="onSelectBeginDate"
										locale="jp-ja"
										:day-format="date => new Date(date).getDate()">
									</v-date-picker>
								</v-menu>
							</template>
							<template v-else>
								<div class="multi-line-label">{{scheduleFormatYearMonthDay(dialog.target.begin)}}</div>
							</template>
						</v-flex>
						<v-flex xs3>
							<template v-if="isEditable">
								<v-menu
									ref="begin_time"
									v-model="begin_time"
									:close-on-content-click="false"
									:nudge-right="40"
									lazy
									transition="scale-transition"
									full-width
									v-if="!isAllday">
									<template v-slot:activator="{ on }">
										<v-btn flat block class="blue--text subheading" v-on="on">{{scheduleFormatTime(dialog.target.begin)}}</v-btn>
									</template>
									<v-time-picker
										v-model='scheduleTimeBegin'
										format="24hr"
										@click:minute="onSelectBeginTime">
									</v-time-picker>
								</v-menu>
								</template>
							<template v-else>
								<div class="label-center text-xs-center" v-if="!isAllday">{{scheduleFormatTime(dialog.target.begin)}}</div>
							</template>
						</v-flex>
						<v-flex xs1 blue--text></v-flex>
						<v-flex offset-xs1 xs2 class="multi-line-label">終了</v-flex>
						<v-flex xs5 class="pl-3">
							<template v-if="isEditable">
								<v-menu
									ref="end_calendar"
									v-model="end_calendar"
									:close-on-content-click="false"
									:nudge-right="40"
									lazy
									transition="scale-transition"
									full-width
								>
									<template v-slot:activator="{ on }">
										<v-btn flat block class="blue--text subheading calendar-btn" v-on="on">{{scheduleFormatYearMonthDay(dialog.target.end)}}</v-btn>
									</template>
									<v-date-picker
										v-model="scheduleEnd"
										no-title
										@input="onSelectEndDate"
										locale="jp-ja"
										:day-format="date => new Date(date).getDate()"
									></v-date-picker>
								</v-menu>
							</template>
							<template v-else>
								<div class="multi-line-label">{{scheduleFormatYearMonthDay(dialog.target.end)}}</div>
							</template>
						</v-flex>
						<v-flex xs3>
							<template v-if="isEditable">
								<v-menu
									ref="end_time"
									v-model="end_time"
									:close-on-content-click="false"
									:nudge-right="40"
									lazy
									transition="scale-transition"
									full-width
									v-if="!isAllday" 
								>
									<template v-slot:activator="{ on }">
										<v-btn flat block class="blue--text subheading" v-on="on">{{scheduleFormatTime(dialog.target.end)}}</v-btn>
									</template>
									<v-time-picker
										v-model='scheduleTimeEnd'
										format="24hr"
										@click:minute="onSelectEndTime"
									></v-time-picker>
								</v-menu>
							</template>
							<template v-else>
								<div class="label-center text-xs-center" v-if="!isAllday">{{scheduleFormatTime(dialog.target.begin)}}</div>
							</template>
						</v-flex>
						<v-flex xs1 blue--text></v-flex>
						<v-flex offset-xs3 xs3 mt-2 class="pl-3 multi-line-label">終日</v-flex>
						<v-flex offset-xs2 pl-4 xs3 mt-2>
							<template v-if="isEditable">
								<v-switch
									v-model="isAllday"
									class="all-day-tggle"
									v-on:input="onInputAllday">
								</v-switch>
							</template>
							<template v-else>
								{{ dispayAlldayText }}
							</template>
						</v-flex>
					</v-layout>
				</div>
			</v-container>
			<v-card-actions>
				<v-spacer></v-spacer>
				<v-btn color="primary"
					v-on:click="onSave">保存</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>
<script>
import {strftime} from '../../classes/Const';
import ScheduleTick from '../../classes/ScheduleTick';
import MouseState from '../../classes/MouseState';
import Util from '../../classes/Util';
import MouseStateMachine from '../../classes/MouseStateMachine';

export default {
	props: [
		"dialog",
	],
	data: function() {
		let state_default = new MouseState({
			down: (e, next) => {
				if(this.persistent)
					return;
				if (!this.$refs.dialog)
					return;
				let content = this.$refs.dialog.$refs.content;
				if (content && content.contains(e.target)) {
					next(state_downed);
				}
			},
		});
		let state_downed = new MouseState({
			up: (e, next) => {
				this.tmp_persistent = true;
				setTimeout(() => {
					this.tmp_persistent = false;
				}, 100);
				next(state_default);
			},
		});
		return {
			sm: new MouseStateMachine(state_default),
			begin_calendar: false,
			end_calendar: false,
			begin_time: false,
			end_time: false,
			persistent: false,
			tmp_persistent: false,
		};
	},
	methods: {
		onSelectBeginDate: function() {
			this.begin_calendar = false;
		},
		onSelectEndDate: function() {
			this.end_calendar = false;
		},
		onSelectBeginTime: function() {
			this.begin_time = false;
		},
		onSelectEndTime: function() {
			this.end_time = false;
		},
		onInputAllday: function(e) {
			if (this.dialog) {
				this.dialog.target.all_day = e;
			}
		},
		onClose: function() {
			this.begin_calendar = false;
			this.end_calendar = false;
			this.begin_time = false;
			this.end_time = false;
			
			this.$emit('close');
		},
		onSave: function() {
			this.$store.dispatch('updateSchedule', {
				schedule_code: this.dialog.target.code,
				project_code: this.dialog.target.project_code,
				task_code: this.dialog.target.task_code,
				begin_code: this.dialog.target.begin.code,
				end_code: this.dialog.target.end.code,
				all_day: this.dialog.target.all_day,
			});
			this.onClose();
		},
		onDelete: function() {
			this.$store.dispatch('deleteSchedule', {
				schedule_code: this.dialog.target.code,
				project_code: this.dialog.target.project_code,
				task_code: this.dialog.target.task_code,
			});
			this.onClose();
		},
		scheduleFormatYearMonthDay: function(date){
			if (date === undefined)
				return false;
			return date.strftimeDCL('%Y年%m月%d日 (%A)');
		},
		scheduleFormatTime: function(date){
			if (date === undefined)
				return false;
			return date.strftimeDCL('%H:%M');
		},
		formatDate: function (date) {
			const [year, month, day] = date.split('-')
			return `${year}${month}${day}`
		},
		formatTime: function(time){
			const [hour, min] = time.split(':')
			return `${hour}${min}`
		},
		isNotExistsEnablePicker: function(){
			if (this.begin_calendar)
				return false;
			if (this.end_calendar)
				return false;
			if (this.begin_time)
				return false;
			if (this.end_time)
				return false;
			return true;
		},
		changePickerState: function(val){
			if (val){
				this.persistent = val;
			} else{
				if (this.isNotExistsEnablePicker())
					setTimeout(() =>{
						this.persistent = val;
					},100);
			}
		},
	},
	computed: {
		taskName: function() {
			if (this.dialog.target.task_code == null)
				return "";
			let task = this.$store.getters['task'](this.dialog.target.task_code);
			if (task){
				return task.name;
			} else{
				return "" ;
			}
		},
		projectName: function() {
			if (this.dialog.target.project_code == null)
				return "";
			let project = this.$store.getters['project'](this.dialog.target.project_code);
			if (project){
				return project.name;
			} else{
				return "" ;
			}
		},
		memberName: function() {
			if (this.dialog.target.member_code == null)
				return "" ;
			let member = this.$store.getters['member'](this.dialog.target.member_code);
			if (member){
				return member.name;
			} else{
				return "" ;
			}
		},
		dispayAlldayText: function(){
			if (this.dialog.target.all_day){
				return "オン";
			} else {
				return "オフ";
			}
		},
		scheduleBegin: {
			get: function() {
				if (this.dialog.target.begin) {
					return this.dialog.target.begin.strftimeDCL('%Y-%m-%d');
				} else {
					return strftime('%Y-%m-%d', new Date().toISOString().substr(0, 10));
				}
			},
			set: function(begin) {
				let date = this.formatDate(begin);
				let code =  date + this.dialog.target.begin.strftimeDCL('%H%M');
				let dirty_schedule = this.dialog.target.begin.asDate;
				this.dialog.target.begin = new ScheduleTick({ code: code });
				let diffdate = Util.getDiffDay(this.dialog.target.begin.asDate,dirty_schedule);
				this.dialog.target.end = new ScheduleTick({ code: this.dialog.target.end.addDays(diffdate).strftimeDCL('%Y%m%d%H%M') });
			}
		},
		scheduleEnd: {
			get: function() {
				if (this.dialog.target.end) {
					return this.dialog.target.end.strftimeDCL('%Y-%m-%d');
				} else {
					return strftime('%Y-%m-%d', new Date().toISOString().substr(0, 10));
				}
			},
			set: function(end) {
				let date = this.formatDate(end);
				let code =  date + this.dialog.target.end.strftimeDCL('%H%M');
				this.dialog.target.end = new ScheduleTick({ code: code });
				let diffdate = Util.getDiffDay(this.dialog.target.begin.asDate,this.dialog.target.end.asDate);
				if (diffdate > 0){
					this.dialog.target.begin =  new ScheduleTick({ code: this.dialog.target.end.strftimeDCL('%Y%m%d') + this.dialog.target.begin.strftimeDCL('%H%M') });
				}
			}
		},
		scheduleTimeBegin: {
			get: function() {
				if (this.dialog.target.begin) {
					return this.dialog.target.begin.strftimeDCL('%H:%M');
				} else {
					return ''
				}
			},
			set: function(begin) {
				let time = this.formatTime(begin);
				let code = this.dialog.target.begin.strftimeDCL('%Y%m%d') + time;
				let dirty_schedule = this.dialog.target.begin.asDate;
				this.dialog.target.begin = new ScheduleTick({ code: code });

				let diffminitsu = Util.getDiffMinutes(this.dialog.target.begin.asDate,dirty_schedule);
				this.dialog.target.end = new ScheduleTick({ code: this.dialog.target.end.addMinutes(diffminitsu).strftimeDCL('%Y%m%d%H%M') });
			}
		},
		scheduleTimeEnd: {
			get: function() {
				if (this.dialog.target.end) {
					return this.dialog.target.end.strftimeDCL('%H:%M');
				} else {
					return ''
				}
			},
			set: function(end) {
				let time = this.formatTime(end);
				let code = this.dialog.target.end.strftimeDCL('%Y%m%d') + time;
				this.dialog.target.end = new ScheduleTick({ code: code });

				let difftime = Util.getDiffMinutes(this.dialog.target.begin.asDate,this.dialog.target.end.asDate);
				if (difftime > 0){
					this.dialog.target.begin =  new ScheduleTick({ code: this.dialog.target.begin.strftimeDCL('%Y%m%d') + this.dialog.target.end.strftimeDCL('%H%M') });
				}
			}
		},
		idDisplay: function(){
			if (this.dialog === undefined || this.dialog == null){
				return false;
			} else {
				return true;
			}
		},
		isAllday: {
			get: function() {
				if (this.dialog.target.all_day) {
					return this.dialog.target.all_day;
				} else {
					return false;
				}
			},
			set: function(allday) {
				this.dialog.target.all_day = allday;
			}
		},
		isDisplayTaskName: function() {
			return this.dialog.target.task_code != '';
		},
		isDisplayProjectName: function() {
			return this.dialog.target.project_code != '';
		},
		isDisplayMemberName: function() {
			return this.dialog.target.member_code != '';
		},
		isProjectSchedule: function(){
			return this.dialog.target.isProjectSchedule;
		},
		hasSeveralSchedule: function() {
			if(!this.dialog.target)
				return false;
			
			return this.dialog.schedules.length > 1;
		},
		isPersistent: function() {
			return this.persistent || this.tmp_persistent;
		},
		isEditable: function() {
			return this.$store.getters['chart/isEditable'];
		},
	},
	watch: {
		begin_time:function(val){
			this.changePickerState(val);
		},
		end_time:function(val){
			this.changePickerState(val);
		},
		end_calendar:function(val){
			this.changePickerState(val);
		},
		begin_calendar:function(val){
			this.changePickerState(val);
		},
	},
	mounted: function() {
		this.sm.bind(window);
	},
	beforeDestory: function() {
		this.sm.unbind();
	},
};
</script>
<style>
	.dialog-close {
		top: 0px;
		right: 0px;
	}
	.dialog-schedule-delete {
		top: 0px;
		right: 55px;
	}
	.dialog-schedule-info .multi-line-label {
		display: flex;
		justify-content: flex-start;
		align-items: flex-start;
		font-size: 16px;
		padding-top: 1px;
	}
	.dialog-schedule-info .label-center {
		font-size: 16px;
		padding-top: 1px;
	}
	.dialog-schedule-info-content .v-btn{
		height: 25px;
		min-width: 40px;
		margin: 0px;
	}
	.dialog-schedule-info .all-day-tggle{
		margin-top: 0;
		padding-top: 0;
		padding-left: .5em;
	}
	.dialog-schedule-info .all-day-tggle .v-input__slot{
		margin-bottom: 0 !important;
	}

	.dialog-schedule-info .calendar-btn .v-btn__content{
		display: inline-block;
		text-align: justify;
		text-align-last: justify;
	}
	.dialog-schedule-info .calendar-btn{
		padding: 0;
	}
</style>
